import styled from 'styled-components';

export const MainLinksTitle = styled.h2`
  font-size: 15px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
  margin-bottom: 16px;
`;

export const MainLinksWrapper = styled.div`
  min-width: 230px;
`;

export const LinkRow = styled.div`
  display: flex;
  margin-bottom: 16px;
  :last-child {
    margin-bottom: 0;
  }
  svg {
    width: 24px;
  }
`;

export const SettingLink = styled.a`
  text-decoration: none;
  color: ${(props) => props.theme.colors.brand};
`;

export const WrappedIcon = styled.div`
  display: inline-block;
  color: ${(props) => props.theme.colors.brand};
`;

export const LinkHeader = styled.p`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.text};
  font-weight: 700;
  margin-left: 8px;
`;
